export function isFieldEmptyString(value?: string): boolean {
  return value == null || value === '';
}
